










import dayjs from 'dayjs'
import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'

@Component({
  components: {
  },
})
export default class CDatePicker extends Mixins(MainMixin) {
  @Prop({ default: false }) showLabel!:boolean

  @Prop({ default: false }) future!:boolean

  @Prop({ default: '' }) initialDate!:string

  get today() {
    return dayjs(new Date()).format('YYYY-MM-DD')
  }

  isToday = true

  dialog = false

  dateValue = this.initialDate ? this.initialDate : dayjs(new Date()).format('YYYY-MM-DD')

  get displayDate() {
    return dayjs(this.dateValue).format('ddd, M/D/YY')
  }

  checkCheckbox() {
    if (this.isToday) {
      this.dateValue = dayjs(new Date()).format('YYYY-MM-DD')
      this.$emit('update:value', this.dateValue)
    } else {
      this.dialog = true
    }
  }

  setDate(d:string) {
    this.dateValue = d
    if (d === this.today) {
      this.isToday = true
    } else this.isToday = false
    this.dialog = false
    this.$emit('update:value', d)
  }

  reset() {
    this.dateValue = this.today
    this.isToday = true
    this.$emit('update:value', this.dateValue)
  }

  created() {
    this.$emit('update:value', this.dateValue)
    // this.EventBus.$on('switch-tab', (tab:string) => {
    //   console.log('ok')
    // })
  }
}

